import { handleActions } from 'redux-actions'
import {
  resetVideoStream,
  resetAudioStream,
  iceConnectionState,
  accessGranted,
  accessRejected,
  accessPending,
  accessConfirmationCancelled,
  connectionUnstable,
} from '../actions/webrtcConnection'
import { restartRTC } from './../actions/app'

const initialState = {
  iceConnectionState: '',
  accessState: '',
  accessGranted: false,
  unstable: false,
  videoStream: null,
  audioStream: null,
}

export const webrtcConnectionReducer = handleActions({
  [iceConnectionState] (prevState, action) {
    return {
      ...prevState,
      iceConnectionState: action.payload
    }
  },
  [accessPending] (prevState, action) {
    return {
      ...prevState,
      accessState: action.type
    }
  },
  [accessGranted] (prevState, action) {
    return {
      ...prevState,
      accessState: action.type,
      accessGranted: true,
    }
  },
  [accessRejected] (prevState, action) {
    return {
      ...prevState,
      accessState: action.type
    }
  },
  [accessConfirmationCancelled] (prevState, action) {
    return {
      ...prevState,
      accessState: action.type
    }
  },
  [resetVideoStream] (prevState, action) {
    return {
      ...prevState,
      videoStream: action.payload
    }
  },
  [resetAudioStream] (prevState, action) {
    return {
      ...prevState,
      audioStream: action.payload,
    }
  },
  [connectionUnstable] (prevState, action) {
    return {
      ...prevState,
      unstable: action.payload
    }
  },
  [restartRTC] (prevState) {
    return {
      ...prevState,
      ...initialState,
      accessGranted: prevState.accessGranted,
    }
  }
}, initialState)
